(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["charm-ugc-videos"] && !Shopify.designMode) return;
  try {
    

(function(){
 const initialized=new WeakSet();
 const visibility=new Map();
 const starting=new WeakSet();
 const reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
 function updateSound(video){
  const button=video.closest('.charm-ugc__player').querySelector('.charm-ugc__sound');
  button.setAttribute('aria-pressed',String(!video.muted));
  button.setAttribute('aria-label',video.muted?button.dataset.unmute:button.dataset.mute);
 }
 function start(video){
  const button=video.closest('.charm-ugc__player').querySelector('.charm-ugc__start');
  if(!video.paused || starting.has(video)) return;
  starting.add(video);
  video.play().then(()=>{button.hidden=true;}).catch(()=>{button.hidden=false;}).finally(()=>starting.delete(video));
 }
 function sync(){
  let selected=null,best=.55;
  if(!document.hidden && !reduced.matches){
   visibility.forEach((ratio,video)=>{
    if(!video.isConnected){visibility.delete(video);return;}
    if(ratio>=best){if(!selected || ratio>best){selected=video;best=ratio;}}
   });
  }
  visibility.forEach((ratio,video)=>{
   if(video!==selected && !video.paused) video.pause();
  });
  if(selected) start(selected);
 }
 const observer=new IntersectionObserver(entries=>{
  entries.forEach(entry=>visibility.set(entry.target,entry.isIntersecting?entry.intersectionRatio:0));
  sync();
 },{threshold:[0,.25,.5,.55,.75,1]});
 function setup(){
  document.querySelectorAll('.charm-ugc__video').forEach(video=>{
   if(initialized.has(video)) return;
   initialized.add(video);
   video.controls=false;video.muted=true;video.defaultMuted=true;video.loop=true;video.playsInline=true;
   const player=video.closest('.charm-ugc__player');
   player.querySelector('.charm-ugc__sound').addEventListener('click',()=>{
    const unmute=video.muted;
    if(unmute) document.querySelectorAll('.charm-ugc__video').forEach(other=>{if(other!==video){other.muted=true;updateSound(other);}});
    video.muted=!unmute;
    updateSound(video);
    start(video);
   });
   player.querySelector('.charm-ugc__start').addEventListener('click',()=>start(video));
   observer.observe(video);
  });
 }
 document.addEventListener('visibilitychange',sync);
 document.addEventListener('shopify:section:load',setup);
 if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',setup,{once:true});
 else setup();
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["charminside-photo-guide"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.ci-photo').forEach(root=>{
 const storageKey='charm_meistrams_photo_guide_v1';
 const state={light:'',control:'',mode:'Neutral',kelvin:'5200',power:'60',distance:'80',phone:'',issue:'',lights:[],checklist:[]};
 try{Object.assign(state,JSON.parse(localStorage.getItem(storageKey)||'{}'))}catch(e){}
 const advice={light:{'Ring lempa':'Pakelk šiek tiek aukščiau akių lygio ir stebėk, ar antakyje lieka matoma plaukelių tekstūra.','Video / LED lempa':'Kiekvienai BEFORE / AFTER serijai išlaikyk tą patį aukštį, kampą ir atstumą.','Dvi video lempos':'Abi nustatyk į tą patį spalvos režimą; antra gali būti silpnesnė.'},control:{'Tik ryškumą':'Kontroliuok aplinkos šviesą ir visada fotografuok toje pačioje vietoje.','Nieko nereguliuoju':'Kontroliuok aplinkos šviesą, ekspoziciją ir fotografavimo vietą.','Warm':'Warm gali sustiprinti gelsvus ir varinius tonus.','Neutral':'Neutral – geras pradinis taškas, kai nori mažiau keisti tikrąją antakių spalvą.','Cool':'Cool gali atšaldyti rudą spalvą ir odą.'},phone:{'iPhone':'Naudok 1× kamerą. Paspausk ir palaikyk ties veidu, kol atsiras AE/AF LOCK; ekspoziciją koreguok taip, kad matytųsi plaukeliai.','Samsung':'Naudok 1× kamerą. Jei yra PRO režimas, užfiksuok WB (white balance) ir ekspoziciją BEFORE / AFTER serijai.','Kitas Android':'Naudok 1× kamerą. Jei yra PRO / MANUAL režimas, ieškok WB ir EV kontrolės; išjunk Beauty / Retouch.'},issue:{'Per ryža / šilta':'Išjunk šiltą aplinkos apšvietimą; palygink Neutral režimą arba maždaug 5000–5500 K.','Per pilka / šalta':'Palygink Cool režimą su Neutral ir patikrink white balance.','Antakis atrodo juodas':'Patikrink ekspoziciją, lempos galią ir atstumą. Svarbu matyti atskirus plaukelius.','Oda geltona':'Pirmiausia patikrink, ar kartu su darbo lempa nedega šiltos lubų ar veidrodžio lempos.','BEFORE ≠ AFTER':'Kartok tą pačią lempą, režimą, atstumą, 1× kamerą, ekspoziciją, kampą ir klientės poziciją.'}};
 const pick=(group,value)=>{state[group]=value;save()};
 const save=()=>{try{localStorage.setItem(storageKey,JSON.stringify(state))}catch(e){}render()};
 const render=()=>{
  root.querySelectorAll('[data-choice]').forEach(group=>group.querySelectorAll('button').forEach(btn=>btn.setAttribute('aria-pressed',String(state[group.dataset.choice]===btn.textContent.trim()))));
  root.querySelector('[data-for=kelvin]').hidden=state.control!=='Rodo K / Kelvinus';
  root.querySelector('[data-for=mode]').hidden=state.control!=='Warm · Neutral · Cool';
  ['light','control','phone','issue'].forEach(k=>{const v=k==='control'&&state.control==='Warm · Neutral · Cool'?state.mode:state[k];root.querySelector('[data-advice='+k+']').textContent=advice[k][v]||''});
  root.querySelector('[data-advice=lights]').textContent=state.lights.length?'Pabandyk nufotografuoti palikusi tik pagrindinę darbo lempą ir palygink spalvą.':'Vienas kontroliuojamas šviesos šaltinis palengvina spalvos atkūrimą.';
  ['kelvin','power','distance'].forEach(k=>{root.querySelector('[name='+k+']').value=state[k];root.querySelector('[data-output='+k+']').textContent=state[k]+(k==='kelvin'?' K':k==='power'?'%':' cm')});
  ['light','phone'].forEach(k=>root.querySelector('[data-preset='+k+']').textContent=state[k]||'—');
  root.querySelector('[data-preset=mode]').textContent=state.control==='Rodo K / Kelvinus'?state.kelvin+' K':state.control==='Warm · Neutral · Cool'?state.mode:state.control||'—';
  ['power','distance'].forEach(k=>root.querySelector('[data-preset='+k+']').textContent=state[k]+(k==='power'?'%':' cm'));
  root.querySelectorAll('[data-group=lights] input').forEach(input=>input.checked=state.lights.includes(input.value));
  root.querySelectorAll('[data-group=checklist] input').forEach((input,i)=>input.checked=Boolean(state.checklist[i]));
  const done=state.checklist.filter(Boolean).length;root.querySelector('[data-progress]').textContent=done+' / 5'+(done===5?' · Paruošta fotografuoti':'');
 };
 root.querySelectorAll('[data-choice]').forEach(group=>group.addEventListener('click',event=>{const button=event.target.closest('button');if(button)pick(group.dataset.choice,button.textContent.trim())}));
 root.querySelectorAll('input[type=range]').forEach(input=>input.addEventListener('input',()=>pick(input.name,input.value)));
 root.querySelectorAll('[data-group=lights] input').forEach(input=>input.addEventListener('change',()=>{state.lights=Array.from(root.querySelectorAll('[data-group=lights] input:checked'),el=>el.value);save()}));
 root.querySelectorAll('[data-group=checklist] input').forEach((input,i)=>input.addEventListener('change',()=>{state.checklist[i]=input.checked;save()}));
 render();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
